const BASE_API_URL = '/api';
//const BASE_API_URL = 'https://nw4demo-packages.netwalkapp.com/api';

const NOTIFICATION = {
  EMPTY_CODE: 'A code is required',
  INVALID_CODE: 'Sorry, this code is not valid.',
  EXPIRED_CODE: 'Sorry, this package has expired.',
  UNAVAILABLE: 'Sorry, the server is currently unavailable.'
};

const ARROW_LEFT_KEYCODE = 37;
const ARROW_RIGHT_KEYCODE = 39;
const ARROW_UP_KEYCODE = 38;
const ARROW_DOWN_KEYCODE = 40;

const THEME_TYPES = {
  DARK: 'dark',
  LIGHT: 'light'
};

export {
  BASE_API_URL,
  NOTIFICATION,
  ARROW_LEFT_KEYCODE,
  ARROW_RIGHT_KEYCODE,
  ARROW_UP_KEYCODE,
  ARROW_DOWN_KEYCODE,
  THEME_TYPES
}